import { InAppReview } from '@capacitor-community/in-app-review';
import { Capacitor } from '@capacitor/core';
import { InAppBrowser } from '@capacitor/inappbrowser';
import statsService from './StatisticsService';

const STORE_URLS = {
    android: 'https://play.google.com/store/apps/details?id=com.carlosgutrod.rondaybaciga',
    ios: 'https://apps.apple.com/app/ronda-y-baciga/id6757602821',
    web: 'https://play.google.com/store/apps/details?id=com.carlosgutrod.rondaybaciga'
};

const RATING_STORAGE_KEY = 'ratingPrompted';
const MIN_GAMES_BEFORE_PROMPT = 10;

class RatingService {
    /** Returns the store URL appropriate for the current platform. */
    getStoreUrl() {
        const platform = Capacitor.getPlatform();
        return STORE_URLS[platform] || STORE_URLS.web;
    }

    /** Returns true if the in-app review dialog has already been triggered once. */
    hasBeenPrompted() {
        return !!localStorage.getItem(RATING_STORAGE_KEY);
    }

    /** Marks the review as having been requested so it won't show again. */
    markAsPrompted() {
        localStorage.setItem(RATING_STORAGE_KEY, new Date().toISOString());
    }

    /**
     * Silently requests the native in-app review dialog if all conditions are met:
     *  - Running on a native platform (Android / iOS)
     *  - Not already prompted before
     *  - Player has completed at least MIN_GAMES_BEFORE_PROMPT games
     */
    async requestReviewIfEligible() {
        if (!Capacitor.isNativePlatform()) return;
        if (this.hasBeenPrompted()) return;

        const stats = statsService.loadStats();
        if (stats.gamesPlayed < MIN_GAMES_BEFORE_PROMPT) return;

        try {
            await InAppReview.requestReview();
            this.markAsPrompted();
        } catch (error) {
            console.error('[RatingService] Error requesting in-app review:', error);
        }
    }

    /**
     * Opens the app's store listing directly in an external browser/app.
     * Works on web too (always opens Play Store as fallback).
     */
    async openStoreDirectly() {
        const url = this.getStoreUrl();
        if (Capacitor.isNativePlatform()) {
            try {
                await InAppBrowser.openInExternalBrowser({ url });
            } catch (error) {
                console.error('[RatingService] Error opening store URL:', error);
                window.open(url, '_blank');
            }
        } else {
            window.open(url, '_blank');
        }
    }
}

const ratingService = new RatingService();
export default ratingService;
